module.exports = __webpack_public_path__ + "img/hengxun.ea1f03ea.png";